"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { LogOut, MoreVertical, Settings } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import type * as React from "react";
import { WorkspaceMenuList } from "@/components/layouts/sidebar/WorkspaceMenuList";
import { WorkspaceSwitcher } from "@/components/layouts/sidebar/WorkspaceSwitcher";
import { UserAvatarWithDetails } from "@/components/shared/user-avatar-with-details";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { Skeleton } from "@/components/ui/skeleton";
import { useAuth } from "@/contexts/AuthContext";
import { TOUR_TARGETS } from "@/features/onboarding-tours/orchestrator/tour-target-ids";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import { useUserData } from "@/hooks/useUserData";
import { ROUTES } from "@/lib/constants/routes";
import { cn } from "@/lib/utils";
import { SessionActivity, sessionActivityHandler } from "@/lib/utils/session-activity";
export function AppSidebar(t0) {
  const $ = _c(44);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const {
    signOut
  } = useAuth();
  const pathname = usePathname();
  const {
    workspace,
    workspaceId
  } = useCurrentWorkspace();
  const {
    userData,
    loading
  } = useUserData();
  let t1;
  if ($[2] !== userData) {
    t1 = userData || {};
    $[2] = userData;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    firstName: t2,
    lastName: t3,
    email: t4,
    profilePicture
  } = t1;
  const firstName = t2 === undefined ? "" : t2;
  const lastName = t3 === undefined ? "" : t3;
  const email = t4 === undefined ? "" : t4;
  const t5 = `${firstName} ${lastName}`;
  let t6;
  if ($[4] !== t5) {
    t6 = t5.trim();
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const userName = t6;
  const settingsUrl = `/${workspaceId}${ROUTES.SETTINGS}`;
  let t7;
  if ($[6] !== pathname) {
    t7 = url => {
      sessionActivityHandler.recordActivity({
        pageActivity: [{
          action: SessionActivity.pageActivityActions.PAGE_NAVIGATION,
          payload: {
            currentPagePath: pathname,
            nextPagePath: url
          },
          time: new Date().toISOString()
        }],
        pagePath: pathname
      });
    };
    $[6] = pathname;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const handlePageNavigationActivity = t7;
  let t8;
  if ($[8] !== loading || $[9] !== workspace || $[10] !== workspaceId) {
    t8 = loading || !workspace ? <div className="h-full w-fullflex flex-col p-2 justify-center items-center"><Skeleton className={cn("h-1/2 w-full bg-muted/20 rounded-sm", !workspaceId && "animate-none")} /></div> : <><SidebarHeader className="mb-2"><WorkspaceSwitcher /></SidebarHeader><SidebarContent className="overflow-x-hidden"><WorkspaceMenuList /></SidebarContent></>;
    $[8] = loading;
    $[9] = workspace;
    $[10] = workspaceId;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== email || $[13] !== profilePicture || $[14] !== userName) {
    t9 = <UserAvatarWithDetails className="size-7.5 rounded-full" email={email} profilePicture={profilePicture} userName={userName} />;
    $[12] = email;
    $[13] = profilePicture;
    $[14] = userName;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <MoreVertical className="ml-auto size-4" />;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t9) {
    t11 = <DropdownMenuTrigger asChild={true}><SidebarMenuButton className="bg-sidebar-accent/10! data-[state=open]:bg-sidebar-accent/20! border border-sidebar-accent/10 hover:border-sidebar-accent/30 data-[state=open]:border-sidebar-accent/30 text-sidebar-foreground!" id={TOUR_TARGETS.sidebarUserMenuTrigger} size="lg">{t9}{t10}</SidebarMenuButton></DropdownMenuTrigger>;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== email || $[20] !== profilePicture || $[21] !== userName) {
    t12 = userName && <><DropdownMenuLabel className="font-normal text-sidebar-foreground"><div className="flex items-center justify-center gap-2 px-1 py-1.5 text-left text-sm"><UserAvatarWithDetails email={email} profilePicture={profilePicture} userName={userName} /></div></DropdownMenuLabel><DropdownMenuSeparator className="bg-sidebar-accent/40" /></>;
    $[19] = email;
    $[20] = profilePicture;
    $[21] = userName;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== handlePageNavigationActivity || $[24] !== settingsUrl || $[25] !== userName || $[26] !== workspaceId) {
    t13 = workspaceId && userName && <DropdownMenuItem asChild={true} className="cursor-pointer text-sidebar-foreground/80 hover:text-sidebar-foreground!" onClick={() => {
      handlePageNavigationActivity(settingsUrl);
    }}><Link href={settingsUrl} id={TOUR_TARGETS.sidebarSettingsLink} prefetch={false}><Settings />Settings</Link></DropdownMenuItem>;
    $[23] = handlePageNavigationActivity;
    $[24] = settingsUrl;
    $[25] = userName;
    $[26] = workspaceId;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== signOut) {
    t14 = () => signOut();
    $[28] = signOut;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <LogOut />;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14) {
    t16 = <DropdownMenuItem className="cursor-pointer hover:bg-destructive/20!" id={TOUR_TARGETS.sidebarLogoutButton} onClick={t14} variant="destructive">{t15}Log out</DropdownMenuItem>;
    $[31] = t14;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t12 || $[34] !== t13 || $[35] !== t16) {
    t17 = <DropdownMenuContent align="end" className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg bg-[color-mix(in_oklch,var(--color-sidebar),white_5%)] border-sidebar-accent/40" id={TOUR_TARGETS.sidebarAccountMenu} side="top">{t12}{t13}{t16}</DropdownMenuContent>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t11 || $[38] !== t17) {
    t18 = <SidebarFooter><SidebarMenu><SidebarMenuItem><DropdownMenu>{t11}{t17}</DropdownMenu></SidebarMenuItem></SidebarMenu></SidebarFooter>;
    $[37] = t11;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== props || $[41] !== t18 || $[42] !== t8) {
    t19 = <Sidebar className="bg-transparent" collapsible="icon" {...props}>{t8}{t18}</Sidebar>;
    $[40] = props;
    $[41] = t18;
    $[42] = t8;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  return t19;
}